import axiosInstance from '../axios/axiosInstance';
import { LearningBook, Page } from '../model/response';
import { LearningBookRequest, TableParams } from '../model/request';

export const findAllLearningBooks = async () => {
  const { data } = await axiosInstance.get<LearningBook[]>('learning-books', { params: { fromCMS: true } });
  return data;
};

export const getPageLearningBook = async (tableParams: TableParams, keyword: string) => {
  const params = {
    size: tableParams.pagination ? tableParams.pagination.pageSize : 10,
    page: tableParams.pagination && tableParams.pagination.current ? tableParams.pagination.current - 1 : 0,
    keyword,
  };
  const { data } = await axiosInstance.get<Page<LearningBook>>('learning-books/page', {
    params: params,
  });
  return data;
};

export const findLearningBookById = async (id: string) => {
  const { data } = await axiosInstance.get<LearningBook>('learning-books/' + id);
  return data;
};

export const updateLearningBook = async (id: string, learningBookRequest: LearningBookRequest): Promise<void> => {
  await axiosInstance.put<string>(`learning-books/${id}`, learningBookRequest);
};

export const createLearningBook = async (learningBookRequest: LearningBookRequest): Promise<string> => {
  const { data } = await axiosInstance.post<string>(`learning-books`, learningBookRequest);
  return data;
};

export const deleteLearningBook = async (id: string) => {
  await axiosInstance.delete<void>('learning-books/' + id);
};
